import { fetchLocationBlogPostsReducer } from '@core/features/blog/thunks/fetchLocationBlogPosts.thunk';
import { fetchLocationBlogPostsSilentReducer } from './fetchLocationBlogPostsSilent.thunk';

export { fetchLocationBlogPostsReducer } from './fetchLocationBlogPosts.thunk';

export const blogThunkReducers = {
  ...fetchLocationBlogPostsReducer,
  ...fetchLocationBlogPostsSilentReducer,
};
